import { render, staticRenderFns } from "./ConsultOnline.vue?vue&type=template&id=a54ba0a6&scoped=true&"
import script from "./ConsultOnline.vue?vue&type=script&lang=js&"
export * from "./ConsultOnline.vue?vue&type=script&lang=js&"
import style0 from "./ConsultOnline.vue?vue&type=style&index=0&id=a54ba0a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54ba0a6",
  null
  
)

export default component.exports